import { forwardRef } from 'react';
import { SearchableDropdownOption } from '../index';
import { NoOptions } from './NoOptions';
import { OptionsList } from './OptionsList';
import { OptionsStatus } from './OptionsStatus';

interface ListboxProps {
  options: SearchableDropdownOption[];
  selectedValue: string | string[] | null;
  isMulti: boolean;
  highlightedIndex: number;
  setHighlightedIndex: (index: number) => void;
  onOptionClick: (value: string, label: string) => void;
  isLoading?: boolean;
  error?: string | Error | null;
  searchValue: string;
  hasFilteredOptions: boolean;
}

export const Listbox = forwardRef<HTMLDivElement | null, ListboxProps>(
  (
    {
      options,
      selectedValue,
      isMulti,
      highlightedIndex,
      setHighlightedIndex,
      onOptionClick,
      isLoading,
      error,
      searchValue,
      hasFilteredOptions,
    },
    ref,
  ) => {
    const showOptions = !isLoading && !error;

    return (
      <div
        ref={ref}
        className="max-h-60 overflow-y-auto focus:outline-none"
        role="listbox"
        tabIndex={0}
      >
        <OptionsStatus isLoading={isLoading ?? false} error={error} />
        <OptionsList
          options={options}
          selectedValue={selectedValue}
          isMulti={isMulti}
          highlightedIndex={highlightedIndex}
          setHighlightedIndex={setHighlightedIndex}
          onOptionClick={onOptionClick}
          isShown={showOptions}
        />
        <NoOptions
          {...(searchValue ? { type: 'noOptionsFound', searchValue } : { type: 'noOptions' })}
          isShown={showOptions && !hasFilteredOptions}
        />
      </div>
    );
  },
);

Listbox.displayName = 'Listbox';
